import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { ControlValueAccessorValidatorBase } from '@fi-app/shared/control-value-accessor-validator-base';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, AbstractControl, ValidationErrors } from '@angular/forms';
import { isNullOrUndefined } from '@fi-shared/utils/is-null-or-undefined';
import { Animations } from '@fi-app/shared/utils/animations';

export interface IQuizTimerSettings {
    IsTimerEnabled: boolean;
    TimerMs: number;
}

@Component({
    selector: 'fi-quiz-timer-settings',
    templateUrl: './quiz-timer-settings.component.html',
    styleUrl: './quiz-timer-settings.component.scss',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-quiz-timer-settings' },
    standalone: false,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: FiQuizTimerSettingsComponent,
            multi: true,
        },
        {
            provide: NG_VALIDATORS,
            useExisting: FiQuizTimerSettingsComponent,
            multi: true,
        },
    ],
    animations: [Animations.fadeHeight()],
})
export class FiQuizTimerSettingsComponent extends ControlValueAccessorValidatorBase<IQuizTimerSettings> {
    protected readonly EnableTimerOptions = [
        { value: false, textId: 'settings.no_timer' },
        { value: true, textId: 'settings.with_timer' },
    ];

    protected readonly minuteMs = 60000;
    protected readonly TimerValues = [5, 10, 15, 20, 30, 45, 60].map((value) => value * this.minuteMs);

    protected onEnableTimerChanged(newEnableTimer: boolean): void {
        this.ngModel.IsTimerEnabled = newEnableTimer;
        if (!newEnableTimer) {
            this.ngModel.TimerMs = undefined;
        }
        this.doPropagateChanges();
    }

    public doValidate(c: AbstractControl): ValidationErrors {
        return {
            'timer-settings-required': isNullOrUndefined(this.ngModel.IsTimerEnabled),
            'timer-settings-timer-ms-required': isNullOrUndefined(this.ngModel.TimerMs) && this.ngModel.IsTimerEnabled,
        };
    }
}
